import { Helmet } from 'react-helmet-async';
import { filter } from 'lodash';
import { sentenceCase } from 'change-case';
import { useContext, useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import SwipeableViews from 'react-swipeable-views';
// @mui
import {
  Table,
  Stack,
  Paper,
  Button,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  Grid,
  CircularProgress,
  Box,
  TextField,
  Autocomplete,
  TableHead,
} from '@mui/material';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import PropTypes from 'prop-types';

import {
  GetAllUsers,
  GetCandidate,
  GetVacanciesList,
  PostEvaluateFinalInterview,
  PostEvaluateInterview,
  ReScheduleCandidateInterview,
} from 'src/components/services/httpServices';
import { AuthContext } from 'src/components/Context/Auth/auth.context';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}
function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    'aria-controls': `full-width-tabpanel-${index}`,
  };
}
TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};
export default function InterviewDetailPage() {
  let { id, candidateId } = useParams();
  const navigate = useNavigate();
  const [vertical, setVertical] = useState('bottom');
  const [horizontal, setHorizontal] = useState('right');
  const [open, setOpen] = useState(false);
  const [saved, setSaved] = useState(false);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState('sdsdsdsds');
  const [candidate, setCandidate] = useState({});
  const [selectedStatusTypes, setSelectedStatusTypes] = useState(null);
  const [interview, setInterview] = useState(null);
  const [candidatePanalistInterview, setCandidatePanalistInterview] = useState(null);
  const [isPanelist, setIsPanelist] = useState(false);
  const [value, setValue] = useState('');

  const [vacancies, setVacancies] = useState(null);
  const [selectedVacancy, setSelectedVacancy] = useState(null);
  const [selectedInterviewType, setSelectedInterviewType] = useState(null);
  const [users, setUsers] = useState([]);
  const [selectedPanelists, setSelectedPanelists] = useState([]);

  const interviewDateRef = useRef('');
  const startDateRef = useRef('');
  const endDateRef = useRef('');

  const interviewTypes = [
    { value: 'Initial Interview' },
    { value: 'Employer Interview' },
    { value: 'Final Interview' },
  ];
  let {
    authState: { userId },
  } = useContext(AuthContext);
  const scoreRef = useRef('');
  const remarksRef = useRef('');
  const finalRemarksRef = useRef('');
  const finalScoreRef = useRef('');

  const fetch = async (event) => {
    const savedCandidate = await GetCandidate(candidateId);
    const savedInterview = savedCandidate?.mstCandidateInterviews.find((e) => e.id == id);
    const vacanciesList = await GetVacanciesList();
    setVacancies(vacanciesList);

    const savedUsers = await GetAllUsers();
    setUsers(savedUsers.filter((e) => e.deptId == 6 || e.userRoleId == 1));
    console.log('savedCandidate', savedCandidate);
    console.log('vacanciesList', vacanciesList);
    setInterview(savedInterview);

    setSelectedPanelists(
      savedUsers.filter((obj1) =>
        savedInterview.mstCandidateInterviewPanelists.some((obj2) => obj1.id === obj2.panelistUserId)
      )
    );
    var logedInPanelist = savedInterview?.mstCandidateInterviewPanelists?.find((e) => e.panelistUserId == userId);
    if (logedInPanelist) {
      setIsPanelist(true);
    } else {
      setIsPanelist(false);
    }
    setCandidatePanalistInterview(logedInPanelist);
    console.log('logedInPanelist', logedInPanelist);
    setCandidate(savedCandidate);
    setLoading(false);
  };
  useEffect(() => {
    fetch();
  }, []);

  const handleClose = () => {
    setOpen(false);
  };

  const SaveScoring = async (event) => {
    event.preventDefault();
    setLoading(true);

    const payload = {
      score: scoreRef.current.value,
      remarks: remarksRef.current.value,
    };

    console.log(payload);
    let response = await PostEvaluateInterview(id, payload);
    console.log('PostResponse:', response);

    if (response != null) {
      setMessage(response);
      setSaved(true);
      setOpen(true);
      setLoading(false);
      setTimeout(() => {
        // navigate(`/app/Recruitment`);
        navigate(-1);
      }, 2000);
    } else {
      setMessage(response);
      setSaved(false);
      setOpen(true);
      setLoading(false);
      // setPosting(false);
    }
  };

  const SaveFinalScoring = async (event) => {
    event.preventDefault();
    setLoading(true);

    const payload = {
      score: finalScoreRef.current.value,
      remarks: finalRemarksRef.current.value,
      status: selectedStatusTypes?.value,
    };

    console.log(payload);
    let response = await PostEvaluateFinalInterview(id, payload);
    console.log('PostResponse:', response);

    if (response != null) {
      setMessage(response);
      setSaved(true);
      setOpen(true);
      setLoading(false);
      setTimeout(() => {
        navigate(-1);
      }, 2000);
    } else {
      setMessage(response);
      setSaved(false);
      setOpen(true);
      setLoading(false);
      // setPosting(false);
    }
  };

  const ScheduleCandidateInterview = async (event) => {
    event.preventDefault();
    if (selectedPanelists.length <= 0) {
      alert('Please Select Panelists');
    } else {
      setLoading(true);

      const candidateInterview = {
        interviewType: selectedInterviewType?.value,
        interviewDate: interviewDateRef.current.value,
        interviewStart: startDateRef?.current?.value,
        interviewEnd: endDateRef?.current?.value,
        mstCandidateId: candidateId,
        mstVacancyId: selectedVacancy?.id,
      };
      const payload = {
        candidateInterview: candidateInterview,
        users: selectedPanelists,
      };

      console.log(payload);
      let response = await ReScheduleCandidateInterview(id, payload);
      console.log('PostResponse:', response);

      if (response.status == 200) {
        setMessage('Interview Scheduled Successfully.');
        setSaved(true);
        setOpen(true);
        let clientSaved = candidate;
        clientSaved.mstCandidateInterviews = response.data;
        setCandidate(clientSaved);
        setLoading(false);
      } else {
        setMessage(response.data);
        setSaved(false);
        setOpen(true);
        setLoading(false);
      }
    }
  };
  //console.log('company', company);
  const statusTypes = [
    { value: 'Pending' },
    { value: 'Hired' },
    { value: 'Longlisted' },
    { value: 'Canceled' },
    { value: 'Rejected' },
  ];

  const handleInputChange = (event) => {
    const inputValue = event.target.value;
    const numericValue = inputValue.replace(/[^0-9]/g, ''); // remove non-numeric characters
    setValue(numericValue);
  };
  const handleInputBlur = () => {
    if (value === '') return; // empty value is allowed
    let numericValue = parseInt(value, 10);
    if (isNaN(numericValue)) numericValue = 0; // default to 0 if NaN
    numericValue = Math.min(10, Math.max(0, numericValue)); // enforce minimum and maximum values
    setValue(numericValue.toString());
  };
  const ChangePanelistHandle = (panelist) => {
    console.log('Event:', panelist);
    setSelectedPanelists(panelist);
  };
  return (
    <>
      <Helmet>
        <title> Candidate | Immigration System </title>
      </Helmet>
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            Candidate:
            <span style={{ color: '#ad1f22' }}>
              {'   '}
              {candidate?.firstName} {candidate?.lastName}
            </span>
          </Typography>
          <Stack direction="row" spacing={2}>
            <Button
              onClick={() => {
                navigate(-1);
              }}
              variant="contained"
            >
              Back
            </Button>
            {/* <Button type="submit" variant="contained">
                Save
              </Button> */}
          </Stack>
        </Stack>
        {loading ? (
          <Grid display="flex" alignItems="center" justifyContent="center" height="40vh" container>
            <CircularProgress size={60} thickness={3} value={100} />
          </Grid>
        ) : (
          <Box
            p={4}
            component={Paper}
            boxShadow={3}
            sx={{ border: 0, borderColor: 'primary.main', borderRadius: '16px' }}
          >
            <Grid container spacing={3}>
              <Grid item xs={6} sm={3} md={3}>
                <Typography variant="h6" color="initial">
                  First Name :{' '}
                </Typography>
                <Typography variant="subtitle" color="initial">
                  {candidate?.firstName}
                </Typography>
              </Grid>
              <Grid item xs={6} sm={3} md={3}>
                <Typography variant="h6" color="initial">
                  Last Name :{' '}
                </Typography>
                <Typography variant="subtitle" color="initial">
                  {candidate?.lastName}
                </Typography>
              </Grid>
              <Grid item xs={6} sm={3} md={3}>
                <Typography variant="h6" color="initial">
                  Contact :{' '}
                </Typography>
                <Typography variant="subtitle" color="initial">
                  {candidate?.contact}
                </Typography>
              </Grid>
              <Grid item xs={6} sm={3} md={3}>
                <Typography variant="h6" color="initial">
                  Email Address :{' '}
                </Typography>
                <Typography variant="subtitle" color="initial">
                  {candidate?.email}
                </Typography>
              </Grid>
              <Grid item xs={6} sm={3} md={3}>
                <Typography variant="h6" color="initial">
                  Father Name :{' '}
                </Typography>
                <Typography variant="subtitle" color="initial">
                  {candidate?.fatherName}
                </Typography>
              </Grid>
              <Grid item xs={6} sm={3} md={3}>
                <Typography variant="h6" color="initial">
                  Address :{' '}
                </Typography>
                <Typography variant="subtitle" color="initial">
                  {candidate?.address}
                </Typography>
              </Grid>

              <Grid item xs={6} sm={3} md={3} hidden>
                <Typography variant="h6" color="initial">
                  Identity Type :{' '}
                </Typography>
                <Typography variant="subtitle" color="initial">
                  {candidate?.identityType}
                </Typography>
              </Grid>
              <Grid item xs={6} sm={3} md={3} hidden>
                <Typography variant="h6" color="initial">
                  Identity No :{' '}
                </Typography>
                <Typography variant="subtitle" color="initial">
                  {candidate?.identityNumber}
                </Typography>
              </Grid>
              <Grid item xs={6} sm={3} md={3} hidden>
                <Typography variant="h6" color="initial">
                  Identity Expiry:{' '}
                </Typography>
                <Typography variant="subtitle" color="initial">
                  {candidate?.identityExpiry?.split('T')[0]}
                </Typography>
              </Grid>
              <Grid item xs={6} sm={3} md={3}>
                <Typography variant="h6" color="initial">
                  Marital Status :{' '}
                </Typography>
                <Typography variant="subtitle" color="initial">
                  {candidate?.maritalStatus}
                </Typography>
              </Grid>
              <Grid item xs={6} sm={3} md={3}>
                <Typography variant="h6" color="initial">
                  Gender :{' '}
                </Typography>
                <Typography variant="subtitle" color="initial">
                  {candidate?.gender}
                </Typography>
              </Grid>
              <Grid item xs={6} sm={3} md={3} hidden>
                <Typography variant="h6" color="initial">
                  Blood Group :{' '}
                </Typography>
                <Typography variant="subtitle" color="initial">
                  {candidate?.bloodGroup}
                </Typography>
              </Grid>
              <Grid item xs={6} sm={3} md={3}>
                <Typography variant="h6" color="initial">
                  Date of Birth :{' '}
                </Typography>
                <Typography variant="subtitle" color="initial">
                  {candidate?.dateOfBirth?.split('T')[0]}
                </Typography>
              </Grid>
              <Grid item xs={6} sm={3} md={3}>
                <Typography variant="h6" color="initial">
                  Joining Date :{' '}
                </Typography>
                <Typography variant="subtitle" color="initial">
                  {candidate?.joiningDate?.split('T')[0]}
                </Typography>
              </Grid>
              <Grid item xs={6} sm={3} md={3}>
                <Typography variant="h6" color="initial">
                  Recruitment Method :{' '}
                </Typography>
                <Typography variant="subtitle" color="initial">
                  {candidate?.recruitmentMethod}
                </Typography>
              </Grid>
              <Grid item xs={6} sm={3} md={3} hidden>
                <Typography variant="h6" color="initial">
                  Reffered By :{' '}
                </Typography>
                <Typography variant="subtitle" color="initial">
                  {candidate?.refferedBy}
                </Typography>
              </Grid>
              <Grid item xs={6} sm={3} md={3} hidden>
                <Typography variant="h6" color="initial">
                  Reference 1 :{' '}
                </Typography>
                <Typography variant="subtitle" color="initial">
                  {candidate?.reference1}
                </Typography>
              </Grid>
              <Grid item xs={6} sm={3} md={3} hidden>
                <Typography variant="h6" color="initial">
                  Reference 2 :{' '}
                </Typography>
                <Typography variant="subtitle" color="initial">
                  {candidate?.reference2}
                </Typography>
              </Grid>
              <Grid item xs={6} sm={3} md={3} hidden>
                <Typography variant="h6" color="initial">
                  Reference 3 :{' '}
                </Typography>
                <Typography variant="subtitle" color="initial">
                  {candidate?.reference3}
                </Typography>
              </Grid>
            </Grid>
          </Box>
        )}{' '}
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5} marginTop={4}>
          <Typography variant="h4" gutterBottom>
            Panelists
          </Typography>

          <Stack direction="row" spacing={2}>
            {interview?.evaluated ? (
              <Typography variant="h4" gutterBottom>
                Candidate Status:{' '}
                <span style={{ color: '#ad1f22' }}>
                  {' '}
                  {'   '}
                  {interview?.status}
                </span>
              </Typography>
            ) : null}
            {/* <Button type="submit" variant="contained">
              Save
            </Button> */}
          </Stack>
        </Stack>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Box
              p={4}
              component={Paper}
              boxShadow={3}
              sx={{ border: 0, borderColor: 'primary.main', borderRadius: '16px' }}
            >
              {' '}
              <TableContainer component={Paper}>
                <Table size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell>Sr#</TableCell>
                      <TableCell>Panelist Name</TableCell>
                      <TableCell>Score</TableCell>
                      <TableCell>Remarks</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {interview?.mstCandidateInterviewPanelists?.map((row, index) => (
                      <TableRow key={index + 1}>
                        <TableCell>{index + 1}</TableCell>
                        <TableCell>{row.panelistUserName}</TableCell>
                        <TableCell>{row.score}</TableCell>
                        <TableCell>{row.remarks}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          </Grid>
        </Grid>
        {/* Add check Here */}
        {/* {loading ? (
          <Grid display="flex" alignItems="center" justifyContent="center" height="40vh" container>
            <CircularProgress size={60} thickness={3} value={100} />
          </Grid>
        ) : (

        ) */}
        {loading ? (
          <Grid display="flex" alignItems="center" justifyContent="center" height="40vh" container>
            <CircularProgress size={60} thickness={3} value={100} />
          </Grid>
        ) : interview?.evaluated != true && candidatePanalistInterview?.score == null && isPanelist == true ? (
          <form onSubmit={SaveScoring}>
            <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5} marginTop={4}>
              <Typography variant="h4" gutterBottom>
                Interview Evaluation for Vacancy{' '}
                <span style={{ color: '#ad1f22' }}>
                  {'   '}
                  {interview?.mstVacancy?.vacancyName}
                </span>
              </Typography>
              <Stack direction="row" spacing={2}>
                <Button type="submit" variant="contained">
                  Evaluate
                </Button>
              </Stack>
            </Stack>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Box
                  p={4}
                  component={Paper}
                  boxShadow={3}
                  sx={{ border: 0, borderColor: 'primary.main', borderRadius: '16px' }}
                >
                  <Grid container spacing={3}>
                    <Grid item xs={12} sm={4} md={4}>
                      {' '}
                      <TextField
                        inputRef={scoreRef}
                        required
                        variant="outlined"
                        fullWidth
                        size="small"
                        multiline
                        rows={2}
                        label="Score only in numbers max 10"
                        inputProps={{
                          inputMode: 'numeric',
                          pattern: '[0-9]*',
                          min: 0, // minimum value
                          max: 10, // maximum value
                        }}
                        value={value}
                        onBlur={handleInputBlur}
                        onChange={handleInputChange}
                      />
                    </Grid>
                    <Grid item xs={12} sm={4} md={8}>
                      <TextField
                        label="Remarks"
                        inputRef={remarksRef}
                        required
                        variant="outlined"
                        fullWidth
                        size="small"
                        multiline
                        rows={2}
                      />
                    </Grid>
                  </Grid>
                </Box>
              </Grid>
            </Grid>
          </form>
        ) : null}
        {interview?.userId != userId ? null : (
          <>
            <form onSubmit={SaveFinalScoring}>
              <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5} marginTop={4}>
                <Typography variant="h4" gutterBottom>
                  Final Evaluation for Vacancy{' '}
                  <span style={{ color: '#ad1f22' }}>
                    {'   '}
                    {interview?.mstVacancy?.vacancyName}
                  </span>
                </Typography>
                <Stack direction="row" spacing={2}>
                  <Button type="submit" disabled={interview?.evaluated} variant="contained">
                    Save Final Evaluation
                  </Button>
                </Stack>
              </Stack>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Box
                    p={4}
                    component={Paper}
                    boxShadow={3}
                    sx={{ border: 0, borderColor: 'primary.main', borderRadius: '16px' }}
                  >
                    <Grid container spacing={3}>
                      <Grid item xs={12} sm={4} md={6}>
                        {' '}
                        <Autocomplete
                          id="status"
                          size="small"
                          options={statusTypes}
                          defaultValue={statusTypes.find((e) => e.value == interview?.status)}
                          getOptionLabel={(source) => source.value}
                          disabled={interview?.evaluated}
                          renderInput={(params) => <TextField required {...params} label="Status" variant="outlined" />}
                          onChange={(event, status) => setSelectedStatusTypes(status)}
                        />
                      </Grid>

                      <Grid item xs={12} sm={4} md={6}>
                        {' '}
                        <TextField
                          label="Aggregated Score"
                          value={interview?.score}
                          disabled
                          variant="outlined"
                          fullWidth
                          inputRef={finalScoreRef}
                          size="small"
                        />
                      </Grid>
                      <Grid item xs={12} sm={4} md={12}>
                        <TextField
                          label="Remarks"
                          required
                          variant="outlined"
                          fullWidth
                          size="small"
                          defaultValue={interview?.remarks}
                          disabled={interview?.evaluated}
                          multiline
                          rows={4}
                          inputRef={finalRemarksRef}
                        />
                      </Grid>
                    </Grid>
                  </Box>
                </Grid>
              </Grid>
            </form>
            <form onSubmit={ScheduleCandidateInterview}>
              <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5} marginTop={4}>
                <Typography variant="h4" gutterBottom>
                  Re-Schedule Interview
                </Typography>
                <Stack direction="row" spacing={2}>
                  <Button type="submit" disabled={interview?.evaluated} variant="contained">
                    Save
                  </Button>
                </Stack>
              </Stack>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Box
                    p={4}
                    component={Paper}
                    boxShadow={3}
                    sx={{ border: 0, borderColor: 'primary.main', borderRadius: '16px' }}
                  >
                    <Grid container spacing={3}>
                      <Grid item xs={12} sm={4} md={3}>
                        <Autocomplete
                          id="vacancyId"
                          size="small"
                          disabled
                          options={vacancies}
                          defaultValue={vacancies.find((e) => e.id == interview.mstVacancyId)}
                          getOptionLabel={(source) => source?.vacancyName}
                          renderInput={(params) => (
                            <TextField required {...params} label="Vacancy" variant="outlined" />
                          )}
                          onChange={(event, vacancy) => setSelectedVacancy(vacancy)}
                        />
                      </Grid>
                      <Grid item xs={12} sm={4} md={3}>
                        <Autocomplete
                          id="interviews"
                          size="small"
                          disabled
                          options={interviewTypes}
                          defaultValue={interviewTypes.find((e) => e.value == interview.interviewType)}
                          getOptionLabel={(source) => source.value}
                          renderInput={(params) => <TextField {...params} label="Interview Type" variant="outlined" />}
                          onChange={(event, interviewType) => setSelectedInterviewType(interviewType)}
                        />
                      </Grid>

                      <Grid item xs={12} sm={4} md={3}>
                        <TextField
                          label="Interview Date"
                          type="date"
                          required
                          InputLabelProps={{ shrink: true }}
                          defaultValue={interview.interviewDate.split('T')[0]}
                          variant="outlined"
                          fullWidth
                          size="small"
                          inputRef={interviewDateRef}
                        />
                      </Grid>

                      <Grid item xs={12} sm={4} md={3}>
                        <TextField
                          label="Start Time"
                          type="time"
                          required
                          InputLabelProps={{ shrink: true }}
                          defaultValue={interview.interviewStart}
                          variant="outlined"
                          fullWidth
                          size="small"
                          inputRef={startDateRef}
                        />
                      </Grid>
                      <Grid item xs={12} sm={4} md={3}>
                        <TextField
                          label="End Time"
                          type="time"
                          required
                          InputLabelProps={{ shrink: true }}
                          defaultValue={interview.interviewEnd}
                          variant="outlined"
                          fullWidth
                          size="small"
                          inputRef={endDateRef}
                        />
                      </Grid>
                      <Grid item xs={12} sm={4} md={6}>
                        {' '}
                        <Autocomplete
                          multiple
                          size="small"
                          options={users}
                          //defaultValue={interview.mstCandidateInterviewPanelists}
                          getOptionLabel={(option) => option.name}
                          renderInput={(params) => <TextField {...params} variant="outlined" label="Panelists" />}
                          onChange={(event, panelist) => ChangePanelistHandle(panelist)}
                          disabled
                          value={users.filter((obj1) =>
                            interview.mstCandidateInterviewPanelists.some((obj2) => obj1.id === obj2.panelistUserId)
                          )}
                        />
                      </Grid>
                    </Grid>
                  </Box>
                </Grid>
              </Grid>
            </form>
          </>
        )}
      </Container>
      {saved ? (
        <Snackbar
          anchorOrigin={{ vertical, horizontal }}
          key={vertical + horizontal}
          open={open}
          autoHideDuration={4000}
          onClose={handleClose}
        >
          <Alert elevation={6} variant="filled" onClose={handleClose} severity="success">
            {message}
          </Alert>
        </Snackbar>
      ) : (
        <Snackbar
          key={vertical + horizontal}
          anchorOrigin={{ vertical, horizontal }}
          open={open}
          autoHideDuration={4000}
          onClose={handleClose}
        >
          <Alert elevation={6} variant="filled" onClose={handleClose} severity="error">
            {message}
          </Alert>
        </Snackbar>
      )}
    </>
  );
}
